import _get from 'lodash/get';
import jquery from 'jquery';
import _Singleton from '@/tools/singleton';

import { compare, favorites, search, feedback, comments, reviews, menu, accessories, product, addCartCounter, triggerEvents, ajaxReviews, widget } from '@/ui/ui-light';
import { ajaxProducts, ajaxProduct, ajaxFilter } from '@/ui/ui-medium';
import { cart, quickCheckout } from '@/ui/ui-heavy';

var CommonUI = function () {
  var self = this;
  var InSalesUI = _get(window, 'InSalesUI', {});

  self.compare = compare;
  self.favorites = favorites;
  self.cart = cart;
  self.quickCheckout = quickCheckout;
  self.search = search;
  self.feedback = feedback;
  self.comments = comments;
  self.reviews = reviews;
  self.menu = menu;
  self.product = product;
  self.addCartCounter = addCartCounter;
  self.triggerEvents = triggerEvents;
  self.ajaxFilter = ajaxFilter;
  self.ajaxProducts = ajaxProducts;
  self.ajaxProduct = ajaxProduct;
  self.ajaxReviews = ajaxReviews;
  self.widget = widget;
  self.accessories = accessories;

  InSalesUI.openQuickCheckoutModal = self.quickCheckout.openQuickCheckoutModal.bind(self.quickCheckout);
  InSalesUI.initAjaxInstance = self.cart.initAjaxInstance.bind(self.cart);
  InSalesUI.bindUpdateCart = function ($items) {
    var items = $items || jquery('[data-item-id]');
    Products.initInstance(items);
    self.cart._bindUpdateCart();
  }

  window.InSalesUI = InSalesUI;
};

export default _Singleton(CommonUI).getInstance();
